import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
  return (
    <div className="page">
      <div className="wrap notfound">
        <div className="mono" style={{ fontSize: 13, color: 'var(--fg3)' }}>404</div>
        <h1>Destination unreachable</h1>
        <p className="mono" style={{ fontSize: 13, color: 'var(--fg3)' }}>
          no route to host · packet dropped · TTL exceeded
        </p>
        <p style={{ marginTop: 26 }}>
          <Link to="/" className="btn">Return to origin</Link>
        </p>
      </div>
    </div>
  );
}

export default NotFound;
